var _rect, _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _path7, _path8, _path9, _circle3, _path10, _path11, _path12, _path13, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSchool05(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.933594,
    y: 0.529297,
    width: 350,
    height: 233,
    fill: "#E7AD8D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211.623 99.875C211.623 95.4567 215.205 91.875 219.623 91.875H314.506C318.925 91.875 322.506 95.4567 322.506 99.875V163.157H211.623V99.875Z",
    fill: "#394374"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M239.029 74.5293C239.029 70.111 242.611 66.5293 247.029 66.5293H286.471C290.889 66.5293 294.471 70.111 294.471 74.5293V163.156H239.029V74.5293Z",
    fill: "#394374"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M207.209 99.875C207.209 95.4567 210.791 91.875 215.209 91.875H310.092C314.511 91.875 318.092 95.4567 318.092 99.875V163.157H207.209V99.875Z",
    fill: "#F3F5FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M228.594 91.875H296.708V163.157H228.594V91.875Z",
    fill: "#D7DAEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M234.615 74.5293C234.615 70.111 238.197 66.5293 242.615 66.5293H282.057C286.475 66.5293 290.057 70.111 290.057 74.5293V163.156H234.615V74.5293Z",
    fill: "#C3CCFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M277.587 92.5826C277.587 101.022 270.956 106.691 263.552 106.136C256.535 105.609 250.049 100.812 250.049 92.9417C250.049 85.0715 256.215 78.6914 263.82 78.6914C271.426 78.6914 277.587 84.7124 277.587 92.5826Z",
    fill: "#A6AFDE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 262.337,
    cy: 91.5621,
    r: 13.4644,
    fill: "#353071"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.337,
    cy: 91.7202,
    r: 11.8804,
    fill: "#F3F5FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M274.218 91.7202C274.218 85.1589 268.899 79.8398 262.338 79.8398C260.329 79.8398 258.438 80.338 256.779 81.2176L271.661 99.0837C273.262 97.0594 274.218 94.5014 274.218 91.7202Z",
    fill: "#D7DAEA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M261.52 83.6421C261.52 83.4234 261.697 83.2461 261.916 83.2461V83.2461C262.134 83.2461 262.312 83.4234 262.312 83.6421V91.1663H261.52V83.6421Z",
    fill: "#353071"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M270.627 91.957C270.846 91.957 271.023 92.1343 271.023 92.353V92.353C271.023 92.5718 270.846 92.7491 270.627 92.7491L263.103 92.7491L263.103 91.957L270.627 91.957Z",
    fill: "#353071"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 261.915,
    cy: 92.3545,
    r: 0.792024,
    fill: "#353071"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M241.744 125.141H262.337V163.158H241.744V125.141Z",
    fill: "#8F87F3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M262.336 125.141H282.929V163.158H262.336V125.141Z",
    fill: "#8F87F3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M240.951 124.589C240.951 123.189 242.086 122.055 243.486 122.055H281.186C282.586 122.055 283.72 123.189 283.72 124.589V124.589C283.72 124.939 283.437 125.223 283.087 125.223H241.585C241.235 125.223 240.951 124.939 240.951 124.589V124.589Z",
    fill: "#8F87F3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M241.745 125.223H282.93V128.394H241.738L241.745 125.223Z",
    fill: "#353071"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 259.961,
    y: 141.855,
    width: 1.58405,
    height: 4.75215,
    rx: 0.792024,
    fill: "#353071"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 263.129,
    y: 141.855,
    width: 1.58405,
    height: 4.75215,
    rx: 0.792024,
    fill: "#353071"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool05);
export default __webpack_public_path__ + "static/media/school_05.5611e40c998094db406668dc686cae74.svg";
export { ForwardRef as ReactComponent };